import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the TableResultsView.
 * @extends JetView
 */
export default class TableResultsView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            id: 'tableResponts', // Unique identifier for the datatable
            select: true, // Enables row selection
            columns: [
                // Column definitions
                { id: 'Nro', header: _('Nro'), width: 100, sort: 'int' }, // Column for number
                { id: 'User', header: _('Usuario'), width: 200, sort: 'int' }, // Column for user
                {
                    id: 'Score',
                    header: _('Puntuación'), // Column for score
                    width: 100,
                    sort: 'int',
                },
            ],
            math: true, // Enables mathematical operations on the datatable
            loadahead: devConfig.getDefaultDataFetch(), // Sets the data fetch strategy
            pager: 'pagerA', // Identifier for the pager component
            url: devConfig.geturlApi() + 'Leagues/GetResults', // API endpoint for data loading
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Retrieves the URL for data loading
        this.on(this.app, 'resultsTable:id', (item) => {
            // Event listener for loading data based on item ID
            grid.clearAll(); // Clears existing data in the grid
            grid.load(url + '?id=' + item.id); // Loads new data based on the selected item ID
        });
    }
}

// FILE DOCUMENTED
